import Vue from 'vue';
import "babel-polyfill";
import 'whatwg-fetch'
import URLSearchParams from '@ungap/url-search-params'
import VModal from 'vue-js-modal'

import Configurator from 'NewConfigurator.vue';
import InfoIcon from "components/InfoIcon.vue";
import PrintQ3D from 'PrintQ3D.vue'
import Versandaufteilung from 'Versandaufteilung.vue';
import {VueDicts} from "classes/vue-dict-filter";

Vue.use(VModal)
Vue.use(VueDicts)

Vue.component( 'InfoIcon', InfoIcon)

Vue.filter('toCurrency', function (value, currency, locale) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat([locale.slice(0,5).replace(/_/g,"-"), /*fallback:*/"de-CH"], {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2
  });

    return formatter.format(value);
});

function extractUrlParams() {
  const conf = {}
  const params = new URLSearchParams(decodeURI(window.location.search))

  const jsonConf = params.get('jsonConf')
  if (jsonConf) {
    try {
      conf.initialConfig = JSON.parse(jsonConf);
      // params.delete('jsonConf')
      // window.location.search = params.toString()

    } catch (e) {
      console.warn(e)
    }
  }
  const addresses = params.get('addresses')
  if( addresses ) {
    try {
      conf.addresses = JSON.parse(addresses);

    } catch (e) {
      console.warn(e)
    }
  }

  const shopItemId = Number.parseInt(params.get('shopItemId'))
  if (shopItemId) {
    try {
      conf.shopItemId = shopItemId;
    } catch (e) {
      console.warn(e)
    }
  }

  const quantity = Number.parseInt(params.get('quantity'))
  conf.initialQuantity = quantity;

  const configId = params.get('configId');
  conf.configId = configId;

  return conf;
}

if (document.getElementById('component_configurator')) {
  let conf = extractUrlParams();

  new Vue({
    el: '#component_configurator',
    render: h => h(Configurator, {props: { initialConfig: conf.initialConfig, initialAddresses: conf.addresses, shopItemId:conf.shopItemId, configId: conf.configId }}),
  });
}

window.Prj.initBasketVue = function () {
// window.addEventListener("DOMContentLoaded", function () {
  const elementsByClassName = document.getElementsByClassName('vue-component_versandaufteilung');
  const versandaufteilungContainers = [...elementsByClassName]
  for ( let el of versandaufteilungContainers) {
    let hasConfig = el.dataset.itemHasConfiguration == 'true';
    const vue = new Vue({
      el: el,
      render: h => h(Versandaufteilung, {props: {isCheckout: true, shopItemId: el.dataset.shopItemId, itemHasConfiguration: hasConfig}}),
    });
  }
}

if ( document.getElementById( 'model3D' ) ) {
  new Vue({
     el: '#model3D',
     render: h => h(PrintQ3D, {props: {message: 'model3D'}})
   });
}
